<template>
  <svg height="0" width="0">
    <defs>
      <clipPath :id="shape">
        <path
            id="a"
            d="M114.543613 340.42868C63.7814053 256.731402 41.5209109 192.685081 47.76213 148.289717c6.2412191-44.395364 42.6260021-80.8186661 109.154349-109.2699059l74.290461 8.1665312 82.442336 107.4446597-16.388025 152.304574-182.717638 33.493104z"
            transform="rotate(22 259.15655433 32.89356458)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    shape: { type: String, required: true },
  },
};
</script>
